module.exports = __webpack_public_path__ + "static/media/suv.775a355d.png";